import { z } from "zod";
import { MetaSchema } from "./shared";

export const WithdrawalSchema = z.object({
  id: z.string().uuid(),
  requestedAt: z.string().datetime(),
  withdrawAvailableAt: z.string().datetime(),
  withdrawableAmount: z.string(),
  principalReturnAt: z.string(),
  status: z.string(),
  completedAt: z.string().datetime().nullable(),
  cancelledAt: z.string().datetime().nullable(),
  cancelReason: z.string().nullable(),
  createdAt: z.string().datetime(),
});

export const InvestmentCycleDetailSchema = z.object({
  id: z.string().uuid(),
  cycleNumber: z.number(),
  status: z.string(),
  principalAmount: z.string(),
  principalReturnEnabled: z.boolean(),
  startedAt: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  withdrawal: WithdrawalSchema.nullable(),
  renewal: z.unknown().nullable(),
});

// Updated parent schema
export const InvestmentCycleItemSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.string().nullable(),
  useGGold: z.boolean().nullable(),
  useProfit: z.boolean().nullable(),
  hash: z.string(),
  created_at: z.string().datetime(),
  completedAt: z.string().datetime(),
  status: z.string(),
  description: z.string().nullable(),
  investmentCycles: z.array(InvestmentCycleDetailSchema),
});

const InvestmentCyclesResponseSchema = z.object({
  data: z.array(InvestmentCycleItemSchema),
  meta: MetaSchema.default,
});

export type Withdrawal = z.infer<typeof WithdrawalSchema>;
export type InvestmentCycleDetail = z.infer<typeof InvestmentCycleDetailSchema>;
export type InvestmentCycleItem = z.infer<typeof InvestmentCycleItemSchema>;
export type InvestmentCyclesResponse = z.infer<
  typeof InvestmentCycleItemSchema
>;

export default InvestmentCyclesResponseSchema;
